
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto} from "../Configuracion";
import {
    CELLTIPO_CADENA,
    CELLTIPO_ENTERO,
    CELLTIPO_FOREIGN,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import {CAMPOTIPO_CADENA} from "../../framework2/ej2/UI/TiposCampos";
import Formulario from "../../framework2/ej2/UI/Formulario";
import {getElementoConfigNombre, getGridConfigNombre} from "../../framework2/ej2/utils/CrudUtilsJPA";
import {BOTONERA_REFRESCAR} from "../../framework2/ej2/UI/FormularioBotonera";
import Titulo from "../../framework2/ej2/UI/Titulo";
import {loadDatos, loadDatosServicio, postServicio} from "../utils/FormularioUtils";
import {Button} from "@blueprintjs/core";

class Utilidades extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {

    }

    corregirCodigosPacientes= () => {
        postServicio(this, "Paciente", "transformarTodosCodigoid", {}, () => {
            alert("Proceso terminado correctamente");
        });
    }

    pedirPoblaciones= () => {
        loadDatosServicio(this, "Poblacion", "getLista", {}, (datos) => {
            console.log("Datos: ", datos);
            alert("Proceso terminado correctamente");
        });
    }

    inicializarDocumentos= () => {
        let parametros= {pathOrigen: '/opt/tomcat/webdocs/dental/docs/Paciente'}
        postServicio(this, "Documento", "iniciarDocumentos", parametros, () => {
            alert("Proceso terminado correctamente");
        });
    }

    render() {
        return (
            <div>
                <Titulo titulo={"UTILIDADES"} soloTitulo={true} />
                {/*<Button text={"Corregir códigos de pacientes."} onClick={this.corregirCodigosPacientes} /> */}
                {<Button text={"Inicializar documentos"} onClick={this.inicializarDocumentos} /> }


                {/*<Button text={"Pedir poblaciones."} onClick={this.pedirPoblaciones} /> */}
            </div>
        )
    }

}

Utilidades.propTypes = {

}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(Utilidades);



